export const THREE_DS_CONFIG = {
  PAGARME: {
    SANDBOX: 'https://3ds2-sdx.pagar.me/v1/3ds2.min.js',
    PRODUCTION: 'https://3ds2.pagar.me/v1/3ds2.min.js'
  },
  PAGARME_API: {
    SANDBOX: 'https://api.pagar.me/test/3ds2',
    PRODUCTION: 'https://api.pagar.me/3ds2'
  },
  TIMEOUTS: {
    TOKEN_CACHE: {
      PAGARME: 10 * 1000,
      CIELO: 60 * 1000
    },
    SCRIPT_LOAD: 5000,
    INIT_DELAY: 200
  },
  CHALLENGE_WINDOW_SIZES: {
    '01': '250 x 400',
    '02': '390 x 400',
    '03': '500 x 600',
    '04': '600 x 400',
    '05': 'Full screen'
  }
};

export const isDevelopment = (): boolean => {
  return import.meta.env.DEV || import.meta.env.VITE_ENVIRONMENT === 'development';
};

export const getScriptUrl = (provider: 'pagarme' | 'cielo'): string => {
  if (provider === 'pagarme') {
    return isDevelopment() ? THREE_DS_CONFIG.PAGARME.SANDBOX : THREE_DS_CONFIG.PAGARME.PRODUCTION;
  }
  return '';
};

export const getCieloTokenEndpoint = (): string => {
  const baseUrl = (import.meta.env.VITE_BASE_CHECKOUT_API_URL || import.meta.env.VITE_BASE_API_URL || '').trim();
  const normalize = (p: string) => (baseUrl.endsWith('/') ? baseUrl : baseUrl + '/') + (p.startsWith('/') ? p.slice(1) : p);
  const version = (import.meta.env.VITE_CIELO_3DS_API_VERSION || 'v2').toLowerCase();
  const endpointV1 = 'api/financial/cielo/3ds/token';
  const endpointV2 = 'api/financial/3ds/token/?provider=cielo';
  return normalize(version === 'v1' ? endpointV1 : endpointV2);
};
